module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "pure-u-md-1-5 pure-u-lg-1-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-md-3-5 pure-u-lg-1-2"
  }, [_c('div', {
    staticClass: "content box padding-30-reactive"
  }, [_c('p', {
    staticClass: "text-align-center"
  }, [_vm._v("\n        You’re on the list! "), _c('br'), _vm._v(" Verde will be released exclusively on the "), _c('strong', {
    staticClass: "underline"
  }, [_vm._v("Tavour app September 8th. "), _c('br'), _vm._v(" Download the app now so you'll be ready!")])]), _vm._v(" "), _c('div', {
    staticClass: "text-align-center"
  }, [_c('a', {
    attrs: {
      "href": "https://itunes.apple.com/us/app/tavour/id956371806?mt=8"
    }
  }, [_c('img', {
    staticClass: "share-buttons",
    attrs: {
      "alt": "Download on the App Store",
      "src": require("../../assets/images/ios.png")
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.tavour.app&hl=en&utm_source=tavour.com&utm_campaign=user_home&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
    }
  }, [_c('img', {
    staticClass: "share-buttons",
    attrs: {
      "width": "auto",
      "alt": "Get it on Google Play",
      "src": require("../../assets/images/android.png")
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-49c61708!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/success/SuccessKUIUAnchorage.vue
// module id = 378
// module chunks = 1